export default __webpack_public_path__ + "assets/json/bigdata.1664b6.json";